import React, { useState, useEffect, useMemo } from 'react';
import { api } from '../api';
import '../styles/PropertiesScreen.css';

const DomainsScreen = ({ user }) => {
    return (
        <div>
            <h1 className="page-title">Domains/ Websites</h1>
            <p>Domains will be managed here later.</p>
        </div>
    );
}
export default DomainsScreen;